export interface EquipamientoLaboratorio {
  id: number;
  laboratorio_id: number;
  tipo_equipamiento_laboratorio_id: number; //(opcional)
  nuevo_equipamiento: string; //(opcional) // se usa solo para enviar otros equipamientos
}

export function createEmptyEquipamientoLaboratorio(): EquipamientoLaboratorio {
  return {
    id: null,
    laboratorio_id: null,
    tipo_equipamiento_laboratorio_id: null,
    nuevo_equipamiento: null
  };
}

export function createEquipamientoLaboratorio(
  params: any
): EquipamientoLaboratorio {
  return {
    ...createEmptyEquipamientoLaboratorio(),
    ...params
  };
}
